import React from 'react'

const SunFilledIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='12'
    height='12'
    viewBox='0 0 12 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M5.35645 2V0.5H6.35645V2H5.35645ZM5.35645 11.5V10H6.35645V11.5H5.35645ZM9.85645 6.5V5.5H11.3564V6.5H9.85645ZM0.356445 6.5V5.5H1.85645V6.5H0.356445ZM9.20645 3.35L8.50645 2.65L9.38145 1.75L10.1064 2.475L9.20645 3.35ZM2.33145 10.25L1.60645 9.525L2.50645 8.65L3.20645 9.35L2.33145 10.25ZM9.38145 10.25L8.50645 9.35L9.20645 8.65L10.1064 9.525L9.38145 10.25ZM2.50645 3.35L1.60645 2.475L2.33145 1.75L3.20645 2.65L2.50645 3.35ZM5.85645 9C5.02311 9 4.31478 8.70833 3.73145 8.125C3.14811 7.54167 2.85645 6.83333 2.85645 6C2.85645 5.16667 3.14811 4.45833 3.73145 3.875C4.31478 3.29167 5.02311 3 5.85645 3C6.68978 3 7.39811 3.29167 7.98145 3.875C8.56478 4.45833 8.85645 5.16667 8.85645 6C8.85645 6.83333 8.56478 7.54167 7.98145 8.125C7.39811 8.70833 6.68978 9 5.85645 9Z'
      fill='currentColor'
    />
  </svg>
)

export default SunFilledIcon
